import { useParams } from 'react-router-dom';

import ClientsOverview from '../../features/clients/layouts/overview';
import CreateClientForm from '../../features/clients/forms/create';
import EditClientForm from '../../features/clients/forms/edit';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
// Which screen shows is decided by the route and never by state:
//   /admin/clients      → the list
//   /admin/clients/new  → the create form, via `mode` (static route, no param)
//   /admin/clients/:id  → the edit form
//
// `id === 'new'` is also checked. It is not redundant paranoia: it is what
// keeps this working if the static route is ever dropped and the :id route
// starts catching that URL, which would otherwise try to edit a client whose
// id is the word "new".

export default function ClientsPage({ mode }) {
    const { id } = useParams();

    if (mode === 'create' || id === 'new') return <CreateClientForm />;
    if (id) return <EditClientForm clientId={id} />;
    return <ClientsOverview />;
}
